<div class="w-full max-w-6xl mx-auto p-6">
  <div class="relative">
    @if (loading()) {
      <div
        class="absolute inset-0 z-40 flex items-start justify-center rounded-xl bg-slate-400/25 backdrop-blur-[2px] pt-24"
        role="status"
        aria-live="polite"
        aria-busy="true">
        <div class="flex flex-col items-center gap-3 rounded-2xl border border-slate-300/80 bg-white/95 px-8 py-6 shadow-lg">
          <i class="pi pi-spin pi-spinner text-3xl text-sky-600"></i>
          <p class="text-sm font-semibold text-slate-800">Cargando liga…</p>
        </div>
      </div>
    }
  <form [formGroup]="form" (ngSubmit)="save()">
    <p-card styleClass="sale-link-form-card">
      <ng-template pTemplate="header">
        <div class="px-4 py-3 border-b border-slate-200 bg-slate-50/50">
          <div class="flex items-center justify-between gap-3">
            <div class="flex items-center gap-3 min-w-0">
              <p-button
                icon="pi pi-arrow-left"
                [rounded]="true"
                [text]="true"
                severity="secondary"
                type="button"
                (onClick)="cancel()"
                pTooltip="Volver al listado"
                tooltipPosition="bottom" />
              <h2 class="text-lg font-semibold text-slate-900 flex items-center gap-2 min-w-0">
                <span class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-sky-100 text-sky-600">
                  <i class="pi pi-link"></i>
                </span>
                <span class="truncate">{{ editMode() ? (linkNumber() || 'Editar liga de pago') : 'Nueva liga de pago' }}</span>
              </h2>
            </div>
            @if (editMode()) {
              <p-button
                icon="pi pi-refresh"
                [rounded]="true"
                [text]="true"
                severity="secondary"
                type="button"
                (onClick)="refreshLink()"
                [loading]="loading()"
                [disabled]="loading()"
                pTooltip="Actualizar liga"
                tooltipPosition="bottom" />
            }
          </div>
        </div>
        @if (editMode()) {
          <div class="flex flex-wrap items-center justify-between gap-2 border-b border-slate-200 bg-slate-50/90 px-3 py-2">
            <div class="flex min-w-0 flex-wrap items-center gap-2">
              <div class="inline-flex min-w-0 items-baseline gap-x-2 rounded-lg border border-slate-200 bg-white px-2.5 py-1.5">
                <span class="text-[11px] font-semibold uppercase tracking-wider text-slate-500">Folio</span>
                <span class="text-sm font-semibold tabular-nums tracking-tight text-slate-900">{{ linkNumber() || '—' }}</span>
              </div>
              <div
                class="inline-flex items-baseline gap-x-1.5 rounded-lg border bg-white px-2.5 py-1.5"
                [ngClass]="linkStatus() === 'CANCELLED' ? 'border-rose-200 bg-rose-50' : 'border-slate-200'">
                <span
                  class="text-[11px] font-semibold tracking-wider"
                  [ngClass]="linkStatus() === 'CANCELLED' ? 'text-rose-600' : 'text-slate-500'">STATUS:</span>
                <span
                  class="text-sm font-medium font-mono"
                  [ngClass]="linkStatus() === 'CANCELLED' ? 'text-rose-700' : 'text-slate-900'">{{ statusLabel() }}</span>
              </div>
            </div>
            <div class="flex flex-wrap items-center justify-end gap-1.5" role="toolbar" aria-label="Acciones de la liga">
              <button
                type="button"
                class="inline-flex h-8 items-center gap-1 rounded-md border border-slate-200/80 bg-white px-2 text-xs font-medium text-slate-700 shadow-sm transition hover:border-sky-300 hover:bg-sky-50 focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-sky-400 disabled:pointer-events-none"
                [class.opacity-40]="loading() || sending() || linkStatus() === 'PAID' || linkStatus() === 'CANCELLED'"
                [class.cursor-not-allowed]="loading() || sending() || linkStatus() === 'PAID' || linkStatus() === 'CANCELLED'"
                (click)="openSendDialog()"
                [disabled]="loading() || sending() || linkStatus() === 'PAID' || linkStatus() === 'CANCELLED'"
                appDisableUnless="SALE_LINK_WRITE"
                pTooltip="Enviar liga de pago"
                tooltipPosition="bottom">
                <i class="pi pi-send text-sky-600 text-sm"></i>
                <span class="hidden sm:inline">Enviar liga</span>
              </button>
              <button
                type="button"
                class="inline-flex h-8 items-center gap-1 rounded-md border border-slate-200/80 bg-white px-2 text-xs font-medium text-slate-700 shadow-sm transition hover:border-sky-300 hover:bg-sky-50 focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-sky-400 disabled:pointer-events-none disabled:opacity-40"
                (click)="openPaymentUrl()"
                [disabled]="loading() || paymentUrlLoading() || !paymentUrl()"
                pTooltip="Ir a la liga de pago"
                tooltipPosition="bottom">
                <i
                  class="pi text-sky-600 text-sm"
                  [ngClass]="paymentUrlLoading() ? 'pi-spinner pi-spin' : 'pi-external-link'"></i>
                <span class="hidden sm:inline">Ver liga</span>
              </button>
              @if (editable()) {
                <button
                  type="button"
                  class="inline-flex h-8 items-center gap-1 rounded-md border border-slate-200/80 bg-white px-2 text-xs font-medium text-slate-700 shadow-sm transition hover:border-rose-300 hover:bg-rose-50 focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-rose-400 disabled:pointer-events-none disabled:opacity-40"
                  (click)="cancelLink()"
                  [disabled]="loading() || saving() || cancelling()"
                  appDisableUnless="SALE_LINK_WRITE"
                  pTooltip="Cancelar liga"
                  tooltipPosition="bottom">
                  <i
                    class="pi text-rose-600 text-sm"
                    [ngClass]="cancelling() ? 'pi-spinner pi-spin' : 'pi-ban'"></i>
                  <span class="hidden sm:inline">Cancelar liga</span>
                </button>
              }
            </div>
          </div>
        }
      </ng-template>

      <p-tabs [value]="activeTab()" (valueChange)="onTabChange($event)">
        <p-tablist>
          <p-tab value="generales" class="flex items-center gap-2! text-inherit">
            <i class="pi pi-receipt"></i>
            <span>Generales</span>
          </p-tab>
          @if (showSalesTab()) {
          <p-tab value="ventas" class="flex items-center gap-2! text-inherit">
            <i class="pi pi-shopping-cart"></i>
            <span>Ventas</span>
          </p-tab>
          }
          @if (showSubscriptionsTab()) {
          <p-tab value="suscripciones" class="flex items-center gap-2! text-inherit">
            <i class="pi pi-sync"></i>
            <span>Suscripciones</span>
          </p-tab>
          }
          @if (showMetadataTab()) {
          <p-tab value="metadata" class="flex items-center gap-2! text-inherit">
            <i class="pi pi-tags"></i>
            <span>Metadata</span>
          </p-tab>
          }
        </p-tablist>
        <p-tabpanels>
          <p-tabpanel value="generales">
      <div class="mb-8">
        <h3 class="text-lg font-semibold text-slate-900 mb-4 flex items-center gap-2">
          <i class="pi pi-file-edit"></i>
          Datos del link de pago
        </h3>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div class="relative min-w-0 w-full self-start">
          <p-floatlabel class="w-full" variant="on">
            <p-select
              inputId="usage"
              formControlName="usage"
              [options]="usages"
              optionLabel="label"
              optionValue="value"
              [disabled]="!editable()"
              styleClass="usage-select w-full" />
            <label for="usage">Tipo <span class="text-red-500">*</span></label>
          </p-floatlabel>
          <i
            class="pi pi-question-circle absolute right-9 inset-y-0 z-10 flex items-center leading-none text-slate-400 cursor-help text-sm"
            [pTooltip]="usageHelp"
            [escape]="false"
            tooltipPosition="top"
            appendTo="body"
            (click)="$event.stopPropagation()"
            (mousedown)="$event.preventDefault(); $event.stopPropagation()"></i>
        </div>
        @if (form.controls.usage.value === 'SUBSCRIPTION') {
          <div class="flex flex-col gap-1">
            <p-floatlabel class="w-full" variant="on">
              <p-select inputId="frequency" formControlName="frequency" [options]="frequencies" optionLabel="label" optionValue="value" [disabled]="!editable()" class="w-full" />
              <label for="frequency">Frecuencia <span class="text-red-500">*</span></label>
            </p-floatlabel>
            <small class="text-slate-500">El primer ciclo empieza el día del pago.</small>
          </div>
        }
        <div class="flex items-start gap-2 md:col-span-2">
          <div class="min-w-0 flex-1 flex flex-col gap-1">
            <p-floatlabel class="w-full" variant="on">
              <p-autocomplete
                inputId="customer"
                formControlName="customer"
                [suggestions]="customerOptions()"
                (completeMethod)="onCustomerSearch($event)"
                optionLabel="displayLabel"
                [minLength]="3"
                [disabled]="!editable()"
                fluid>
                <ng-template #item let-customer>
                  <div class="flex flex-col py-0.5">
                    <span class="text-sm font-medium text-slate-900 leading-snug">{{ customer.comercialName || customer.legalName }}</span>
                    <span class="text-xs text-slate-400 leading-snug">{{ customer.taxId }}</span>
                  </div>
                </ng-template>
              </p-autocomplete>
              <label for="customer">Cliente <span class="text-red-500">*</span></label>
            </p-floatlabel>
            <small class="text-slate-500">Busca por nombre o RFC. Mínimo 3 caracteres.</small>
          </div>
          <p-button
            icon="pi pi-plus"
            [rounded]="true"
            severity="secondary"
            type="button"
            (onClick)="openCustomerDialog()"
            [disabled]="!editable()"
            pTooltip="Nuevo cliente"
            tooltipPosition="top"
            appDisableUnless="CUSTOMER_WRITE" />
        </div>
        <div class="flex flex-col gap-1">
          <p-floatlabel class="w-full" variant="on">
            <p-datepicker inputId="expiresAt" formControlName="expiresAt" [minDate]="minExpiresAt" [defaultDate]="defaultExpiresAt" [showTime]="true" [showClear]="true" hourFormat="24" [disabled]="!editable()" fluid />
            <label for="expiresAt">Vigencia</label>
          </p-floatlabel>
          <small class="text-slate-500">Vacío significa que la liga no vence. No se permiten fechas pasadas.</small>
        </div>
        <div class="flex flex-col gap-1 md:col-span-2">
          <span class="text-sm font-medium text-slate-700">Notas</span>
          <p-editor class="sale-link-notes-editor" formControlName="notes" [style]="{ height: '180px' }" [readonly]="!editable()">
            <ng-template pTemplate="header">
              <span class="ql-formats">
                <button type="button" class="ql-bold" aria-label="Negrita"></button>
                <button type="button" class="ql-italic" aria-label="Cursiva"></button>
                <button type="button" class="ql-underline" aria-label="Subrayado"></button>
              </span>
              <span class="ql-formats">
                <button type="button" class="ql-list" value="ordered" aria-label="Lista numerada"></button>
                <button type="button" class="ql-list" value="bullet" aria-label="Lista con viñetas"></button>
              </span>
              <span class="ql-formats">
                <select class="ql-align" aria-label="Alineación"></select>
              </span>
            </ng-template>
          </p-editor>
          <small class="text-slate-500">Se muestran en el recibo público de la liga.</small>
        </div>
        <div class="md:col-span-2 mt-2 border-t border-slate-200 pt-6">
          <div class="flex items-center justify-between mb-4">
            <div>
              <h3 class="text-lg font-semibold text-slate-900 flex items-center gap-2">
                <i class="pi pi-list"></i>
                Líneas
              </h3>
              <p class="text-sm text-slate-500">Agrega productos a la liga de pago.</p>
            </div>
            <p-button label="Agregar línea" icon="pi pi-plus" type="button" (onClick)="openLineDialog()" [disabled]="!editable()" />
          </div>
          <div class="bg-white rounded-lg shadow-sm border border-slate-200 overflow-x-auto">
            <table class="w-full">
              <thead class="bg-slate-50 border-b border-slate-200">
                <tr>
                  <th class="w-10 px-2 py-3"></th>
                  <th class="px-6 py-3 text-left text-xs font-semibold text-slate-700 uppercase tracking-wider">Descripción</th>
                  <th class="px-6 py-3 text-left text-xs font-semibold text-slate-700 uppercase tracking-wider">Cantidad</th>
                  <th class="px-6 py-3 text-right text-xs font-semibold text-slate-700 uppercase tracking-wider">P. unitario</th>
                  <th class="px-6 py-3 text-right text-xs font-semibold text-slate-700 uppercase tracking-wider">Subtotal</th>
                  <th class="px-6 py-3 text-right text-xs font-semibold text-slate-700 uppercase tracking-wider">Impuestos</th>
                  <th class="px-6 py-3 text-right text-xs font-semibold text-slate-700 uppercase tracking-wider">Total</th>
                  <th class="px-6 py-3 text-right text-xs font-semibold text-slate-700 uppercase tracking-wider">Acciones</th>
                </tr>
              </thead>
              <tbody class="bg-white divide-y divide-slate-200">
                @if (lines().length === 0) {
                  <tr>
                    <td class="px-6 py-6 text-center text-sm text-slate-500" colspan="8">
                      No hay líneas. Agrega un producto para comenzar.
                    </td>
                  </tr>
                }
                @for (line of lines(); track $index) {
                  <tr class="hover:bg-slate-50 transition-colors">
                    <td class="w-10 px-2 py-4 align-top">
                      @if (line.taxes.length) {
                        <button
                          type="button"
                          class="p-1.5 rounded text-slate-500 hover:bg-slate-200 hover:text-slate-700 transition-colors"
                          (click)="toggleLineExpanded($index)"
                          [attr.aria-expanded]="isLineExpanded($index)">
                          <i class="pi text-sm" [class.pi-chevron-right]="!isLineExpanded($index)" [class.pi-chevron-down]="isLineExpanded($index)"></i>
                        </button>
                      }
                    </td>
                    <td class="px-6 py-4 text-sm text-slate-600">{{ line.description }}</td>
                    <td class="px-6 py-4 whitespace-nowrap text-sm text-slate-600">{{ line.quantity }}</td>
                    <td class="px-6 py-4 whitespace-nowrap text-sm text-slate-600 text-right">{{ line.unitPrice | number:'1.2-2' }}</td>
                    <td class="px-6 py-4 whitespace-nowrap text-sm text-slate-600 text-right">{{ line.subtotal | number:'1.2-2' }}</td>
                    <td class="px-6 py-4 whitespace-nowrap text-sm text-slate-600 text-right">{{ line.taxAmount | number:'1.2-2' }}</td>
                    <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-slate-900 text-right">{{ line.totalAmount | number:'1.2-2' }}</td>
                    <td class="px-6 py-4 whitespace-nowrap text-right">
                      <div class="flex justify-end gap-1">
                        <p-button icon="pi pi-pen-to-square" [rounded]="true" [text]="true" severity="secondary" type="button" (onClick)="openLineDialog($index)" [disabled]="!editable()" pTooltip="Editar" tooltipPosition="left" />
                        <p-button icon="pi pi-trash" [rounded]="true" [text]="true" severity="danger" type="button" (onClick)="removeLine($index)" [disabled]="!editable()" pTooltip="Eliminar" tooltipPosition="left" />
                      </div>
                    </td>
                  </tr>
                  @if (isLineExpanded($index) && line.taxes.length) {
                    <tr class="bg-slate-50/70">
                      <td colspan="8" class="px-6 py-3">
                        <div class="pl-8 text-sm">
                          <div class="font-medium text-slate-600 mb-2">Desglose de impuestos</div>
                          <table class="w-full max-w-md border border-slate-200 rounded-lg overflow-hidden">
                            <thead>
                              <tr class="bg-slate-100 border-b border-slate-200">
                                <th class="px-3 py-2 text-left text-xs font-medium text-slate-600">Código</th>
                                <th class="px-3 py-2 text-left text-xs font-medium text-slate-600">Tasa</th>
                                <th class="px-3 py-2 text-left text-xs font-medium text-slate-600 min-w-[5rem]">Tipo</th>
                                <th class="px-3 py-2 text-right text-xs font-medium text-slate-600">Base</th>
                                <th class="px-3 py-2 text-right text-xs font-medium text-slate-600">Monto</th>
                              </tr>
                            </thead>
                            <tbody>
                              @for (tax of line.taxes; track tax.taxCode || $index) {
                                <tr class="border-b border-slate-100 last:border-0">
                                  <td class="px-3 py-2 text-slate-700">{{ tax.taxCode || '—' }}</td>
                                  <td class="px-3 py-2 text-slate-700">{{ formatTaxRate(tax.taxRate) }}</td>
                                  <td class="px-3 py-2 text-slate-700">{{ taxCollectionLabel(tax.collectionType) }}</td>
                                  <td class="px-3 py-2 text-slate-700 text-right">{{ tax.taxBase != null ? (tax.taxBase | number:'1.2-2') : '—' }}</td>
                                  <td class="px-3 py-2 text-slate-700 text-right">{{ tax.taxAmount != null ? (tax.taxAmount | number:'1.2-2') : '—' }}</td>
                                </tr>
                              }
                            </tbody>
                          </table>
                        </div>
                      </td>
                    </tr>
                  }
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
      </div>
          </p-tabpanel>
          @if (showSalesTab()) {
          <p-tabpanel value="ventas">
            <div class="py-4">
              <div class="mb-4 flex flex-wrap items-center justify-between gap-3">
                <h3 class="flex items-center gap-2 text-lg font-semibold text-slate-900">
                  <i class="pi pi-shopping-cart"></i>
                  Ventas de la liga
                </h3>
                <p-button
                  label="Actualizar"
                  icon="pi pi-refresh"
                  (onClick)="loadLinkSales()"
                  type="button"
                  [loading]="salesLoading()"
                  [disabled]="salesLoading()"
                  pTooltip="Actualiza la lista de ventas"
                  severity="secondary"
                  [rounded]="true" />
              </div>
              @if (salesLoading()) {
                <div class="flex items-center gap-2 py-8 text-slate-600">
                  <i class="pi pi-spin pi-spinner"></i>
                  <span>Cargando ventas...</span>
                </div>
              } @else if (linkSales().length === 0) {
                <p class="py-6 text-slate-500">No hay ventas asociadas a esta liga de pago.</p>
              } @else {
                <div class="overflow-hidden overflow-x-auto rounded-lg border border-slate-200">
                  <table class="w-full min-w-[960px]">
                    <thead class="border-b border-slate-200 bg-slate-50">
                      <tr>
                        <th class="whitespace-nowrap px-4 py-3 text-left text-xs font-semibold uppercase text-slate-700">Venta</th>
                        <th class="whitespace-nowrap px-4 py-3 text-left text-xs font-semibold uppercase text-slate-700">Estado</th>
                        <th class="whitespace-nowrap px-4 py-3 text-center text-xs font-semibold uppercase text-slate-700">F. venta</th>
                        <th class="whitespace-nowrap px-4 py-3 text-center text-xs font-semibold uppercase text-slate-700">Inicio de cobro</th>
                        <th class="whitespace-nowrap px-4 py-3 text-center text-xs font-semibold uppercase text-slate-700">Vencimiento</th>
                        <th class="hidden whitespace-nowrap px-4 py-3 text-center text-xs font-semibold uppercase text-slate-700 md:table-cell">F. emisión</th>
                        <th class="whitespace-nowrap px-4 py-3 text-right text-xs font-semibold uppercase text-slate-700">Saldo</th>
                        <th class="whitespace-nowrap px-4 py-3 text-right text-xs font-semibold uppercase text-slate-700">Total</th>
                        <th class="whitespace-nowrap px-4 py-3 text-right text-xs font-semibold uppercase text-slate-700">Acciones</th>
                      </tr>
                    </thead>
                    <tbody class="divide-y divide-slate-200">
                      @for (sale of linkSales(); track sale.id ?? $index) {
                        <tr class="hover:bg-slate-50">
                          <td class="whitespace-nowrap px-4 py-3">
                            <div class="flex items-center gap-3">
                              <div [class]="saleStatusIconClasses(sale.status)">
                                <i [class]="saleStatusIcon(sale.status)"></i>
                              </div>
                              <button
                                type="button"
                                class="block max-w-full truncate text-left text-sm font-medium text-sky-700 underline underline-offset-2 hover:text-sky-900"
                                (click)="openSaleDetails(sale.id)">
                                {{ sale.number || ('#' + sale.id) }}
                              </button>
                            </div>
                          </td>
                          <td class="whitespace-nowrap px-4 py-3">
                            <p-tag class="!text-xs" [severity]="saleStatusSeverity(sale.status)" [value]="saleStatusLabel(sale.status)" />
                          </td>
                          <td class="whitespace-nowrap px-4 py-3 text-center text-sm text-slate-700">
                            @if (sale.dateOfSale) {
                              {{ sale.dateOfSale | date:'dd/MM/yyyy' }}
                            } @else {
                              -
                            }
                          </td>
                          <td class="whitespace-nowrap px-4 py-3 text-center text-sm text-slate-700">
                            {{ formatApiDateOnly(sale.collectionStartDate) || '-' }}
                          </td>
                          <td class="whitespace-nowrap px-4 py-3 text-center text-sm">
                            @if (saleCollectionDueDate(sale); as dueDate) {
                              <span
                                class="inline-flex items-center justify-center gap-1.5"
                                [class.text-red-600]="isDueDateExpired(dueDate)"
                                [class.font-medium]="isDueDateExpired(dueDate)"
                                [class.text-slate-700]="!isDueDateExpired(dueDate)">
                                {{ dueDate | date:'dd/MM/yyyy' }}
                              </span>
                            } @else {
                              -
                            }
                          </td>
                          <td class="hidden whitespace-nowrap px-4 py-3 text-center text-sm text-slate-700 md:table-cell">
                            @if (sale.issueDate) {
                              <div class="flex flex-col items-center leading-tight">
                                <span>{{ sale.issueDate | date:'dd/MM/yyyy' }}</span>
                                <span class="text-xs text-slate-500">{{ sale.issueDate | date:'h:mm a' }}</span>
                              </div>
                            } @else {
                              -
                            }
                          </td>
                          <td class="whitespace-nowrap px-4 py-3 text-right text-sm font-medium text-slate-900">
                            {{ (sale.amountDue ?? 0) | currency:(sale.currency || 'MXN'):'symbol':'1.2-2' }}
                          </td>
                          <td class="whitespace-nowrap px-4 py-3 text-right text-sm font-medium text-slate-900">
                            {{ (sale.total ?? 0) | currency:(sale.currency || 'MXN'):'symbol':'1.2-2' }}
                          </td>
                          <td class="whitespace-nowrap px-4 py-3 text-right">
                            <a
                              [routerLink]="['/sales', sale.id]"
                              class="inline-flex items-center gap-1.5 rounded-md border border-sky-200 bg-sky-50 px-2.5 py-1.5 text-xs font-medium text-sky-800 transition hover:border-sky-300 hover:bg-sky-100"
                              pTooltip="Ver venta"
                              tooltipPosition="top">
                              <span>Ver</span>
                              <i class="pi pi-arrow-up-right text-[10px]"></i>
                            </a>
                          </td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              }
            </div>
          </p-tabpanel>
          }
          @if (showSubscriptionsTab()) {
          <p-tabpanel value="suscripciones">
            <div class="py-4">
              <div class="mb-4 flex flex-wrap items-center justify-between gap-3">
                <h3 class="flex items-center gap-2 text-lg font-semibold text-slate-900">
                  <i class="pi pi-sync"></i>
                  Suscripciones de la liga
                </h3>
                <p-button
                  label="Actualizar"
                  icon="pi pi-refresh"
                  (onClick)="loadLinkSubscriptions()"
                  type="button"
                  [loading]="subscriptionsLoading()"
                  [disabled]="subscriptionsLoading()"
                  pTooltip="Actualiza la lista de suscripciones"
                  severity="secondary"
                  [rounded]="true" />
              </div>
              @if (subscriptionsLoading()) {
                <div class="flex items-center gap-2 py-8 text-slate-600">
                  <i class="pi pi-spin pi-spinner"></i>
                  <span>Cargando suscripciones...</span>
                </div>
              } @else if (linkSubscriptions().length === 0) {
                <p class="py-6 text-slate-500">No hay suscripciones asociadas a esta liga de pago.</p>
              } @else {
                <div class="overflow-hidden overflow-x-auto rounded-lg border border-slate-200">
                  <table class="w-full min-w-[860px]">
                    <thead class="border-b border-slate-200 bg-slate-50">
                      <tr>
                        <th class="whitespace-nowrap px-4 py-3 text-left text-xs font-semibold uppercase text-slate-700">Suscripción</th>
                        <th class="whitespace-nowrap px-4 py-3 text-left text-xs font-semibold uppercase text-slate-700">Estado</th>
                        <th class="whitespace-nowrap px-4 py-3 text-center text-xs font-semibold uppercase text-slate-700">Frecuencia</th>
                        <th class="whitespace-nowrap px-4 py-3 text-center text-xs font-semibold uppercase text-slate-700">Inicio</th>
                        <th class="hidden whitespace-nowrap px-4 py-3 text-center text-xs font-semibold uppercase text-slate-700 md:table-cell">Próximo cobro</th>
                        <th class="whitespace-nowrap px-4 py-3 text-right text-xs font-semibold uppercase text-slate-700">Total</th>
                        <th class="whitespace-nowrap px-4 py-3 text-right text-xs font-semibold uppercase text-slate-700">Acciones</th>
                      </tr>
                    </thead>
                    <tbody class="divide-y divide-slate-200">
                      @for (subscription of linkSubscriptions(); track subscription.id ?? $index) {
                        <tr class="hover:bg-slate-50">
                          <td class="whitespace-nowrap px-4 py-3">
                            <div class="flex items-center gap-3">
                              <div [class]="subscriptionStatusIconClasses(subscription.status)">
                                <i [class]="subscriptionStatusIcon(subscription.status)"></i>
                              </div>
                              <button
                                type="button"
                                class="block max-w-full truncate text-left text-sm font-medium text-sky-700 underline underline-offset-2 hover:text-sky-900"
                                (click)="openSubscriptionDetails(subscription.id)">
                                {{ subscription.number || ('#' + subscription.id) }}
                              </button>
                            </div>
                          </td>
                          <td class="whitespace-nowrap px-4 py-3">
                            <p-tag class="!text-xs" [severity]="subscriptionStatusSeverity(subscription.status)" [value]="subscriptionStatusLabel(subscription.status)" />
                          </td>
                          <td class="whitespace-nowrap px-4 py-3 text-center text-sm text-slate-700">
                            {{ subscriptionFrequencyLabel(subscription.frequency) }}
                          </td>
                          <td class="whitespace-nowrap px-4 py-3 text-center text-sm text-slate-700">
                            @if (subscription.startDate) {
                              {{ subscription.startDate | date:'dd/MM/yyyy' }}
                            } @else {
                              -
                            }
                          </td>
                          <td class="hidden whitespace-nowrap px-4 py-3 text-center text-sm text-slate-700 md:table-cell">
                            @if (subscription.nextBillingDate) {
                              {{ subscription.nextBillingDate | date:'dd/MM/yyyy' }}
                            } @else {
                              -
                            }
                          </td>
                          <td class="whitespace-nowrap px-4 py-3 text-right text-sm font-medium text-slate-900">
                            {{ (subscription.total ?? 0) | currency:(subscription.currency || 'MXN'):'symbol':'1.2-2' }}
                          </td>
                          <td class="whitespace-nowrap px-4 py-3 text-right">
                            <a
                              [routerLink]="['/subscriptions', subscription.id]"
                              class="inline-flex items-center gap-1.5 rounded-md border border-sky-200 bg-sky-50 px-2.5 py-1.5 text-xs font-medium text-sky-800 transition hover:border-sky-300 hover:bg-sky-100"
                              pTooltip="Ver suscripción"
                              tooltipPosition="top">
                              <span>Ver</span>
                              <i class="pi pi-arrow-up-right text-[10px]"></i>
                            </a>
                          </td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              }
            </div>
          </p-tabpanel>
          }
          @if (showMetadataTab()) {
          <p-tabpanel value="metadata">
            <div class="py-4">
              <h3 class="mb-4 flex items-center gap-2 text-lg font-semibold text-slate-900">
                <i class="pi pi-tags"></i>
                Metadata comercial
              </h3>
              @if (metadataRows().length === 0) {
                <p class="py-6 text-slate-500">Esta liga no tiene metadata comercial.</p>
              } @else {
                <div class="overflow-hidden overflow-x-auto rounded-lg border border-slate-200">
                  <table class="w-full min-w-[480px]">
                    <thead class="border-b border-slate-200 bg-slate-50">
                      <tr>
                        <th class="whitespace-nowrap px-4 py-3 text-left text-xs font-semibold uppercase text-slate-700">Llave</th>
                        <th class="whitespace-nowrap px-4 py-3 text-left text-xs font-semibold uppercase text-slate-700">Valor</th>
                      </tr>
                    </thead>
                    <tbody class="divide-y divide-slate-200">
                      @for (row of metadataRows(); track row.key) {
                        <tr>
                          <td class="whitespace-nowrap px-4 py-3 text-sm font-medium text-slate-900">{{ row.key }}</td>
                          <td class="px-4 py-3 text-sm text-slate-700">{{ row.value }}</td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              }
            </div>
          </p-tabpanel>
          }
        </p-tabpanels>
      </p-tabs>

      <ng-template pTemplate="footer">
        <div class="!mt-4 flex justify-end gap-4 mt-1 !p-4 !-m-5 bg-gray-50 p-2 border-t border-slate-200">
          <p-button [label]="editable() ? 'Cancelar' : 'Volver'" severity="secondary" type="button" (onClick)="cancel()" />
          @if (editable()) {
            <p-button
              type="submit"
              [label]="editMode() ? 'Guardar cambios' : 'Crear liga'"
              icon="pi pi-check"
              [loading]="saving() || loading()"
              [disabled]="saving() || loading() || cancelling()"
              appDisableUnless="SALE_LINK_WRITE" />
          }
        </div>
      </ng-template>
    </p-card>
  </form>
  </div>

  @if (lineDialogOpen()) {
    <div class="fixed inset-0 z-50 flex items-center justify-center">
      <div
        class="absolute inset-0 bg-black transition-opacity duration-200"
        [class.bg-opacity-40]="lineModalShown()"
        [class.bg-opacity-0]="!lineModalShown()"
        (click)="closeLineDialog()"></div>
      <div
        class="relative z-10 flex max-h-[90vh] w-full max-w-2xl flex-col overflow-hidden rounded-xl bg-white shadow-xl transform transition-all duration-200"
        [class.opacity-100]="lineModalShown()"
        [class.opacity-0]="!lineModalShown()"
        [class.scale-100]="lineModalShown()"
        [class.scale-95]="!lineModalShown()">
        <div class="flex shrink-0 items-center justify-between gap-3 border-b border-slate-200 bg-slate-100 px-4 py-3">
          <h3 class="text-lg font-semibold text-slate-900">{{ editingLineIndex() == null ? 'Agregar línea' : 'Editar línea' }}</h3>
          <p-button icon="pi pi-times" [rounded]="true" [text]="true" severity="secondary" (onClick)="closeLineDialog()" type="button" />
        </div>
        <div class="min-h-0 flex-1 overflow-y-auto p-6">
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div class="flex flex-col gap-1 md:col-span-2">
              <div class="flex items-start gap-2">
                <p-floatlabel class="w-full min-w-0 flex-1" variant="on">
                  <p-autocomplete
                    inputId="lineProduct"
                    [formControl]="form.controls.lineProduct"
                    [suggestions]="productOptions()"
                    (completeMethod)="onProductSearch($event)"
                    optionLabel="name"
                    placeholder="Busca producto (mín. 3 caracteres)"
                    [minLength]="3"
                    fluid>
                    <ng-template #item let-product>
                      <div class="flex flex-col py-0.5">
                        <span class="text-sm font-medium text-slate-900 leading-snug">{{ product.name }}</span>
                        <span class="text-xs text-slate-400 leading-snug">{{ product.sku }}</span>
                      </div>
                    </ng-template>
                  </p-autocomplete>
                  <label for="lineProduct">Producto</label>
                </p-floatlabel>
                <p-button
                  icon="pi pi-plus"
                  [rounded]="true"
                  severity="secondary"
                  type="button"
                  (onClick)="openProductDialog()"
                  [disabled]="!editable()"
                  pTooltip="Nuevo producto"
                  tooltipPosition="top"
                  appDisableUnless="PRODUCT_WRITE" />
              </div>
              <small class="text-slate-500">Selecciona un producto del catálogo o crea uno nuevo.</small>
            </div>
            <div class="flex flex-col gap-1 md:col-span-2">
              <p-floatlabel class="w-full" variant="on">
                <input
                  pInputText
                  id="lineDescription"
                  [formControl]="form.controls.lineDescription"
                  [maxlength]="250"
                  fluid />
                <label for="lineDescription">Descripción</label>
              </p-floatlabel>
              <small class="text-slate-500">Si está vacía, se iguala al nombre del producto. Puedes personalizarla.</small>
            </div>
            <div class="md:col-span-2 grid grid-cols-1 sm:grid-cols-3 gap-4">
              <div class="flex flex-col gap-1">
                <p-floatlabel class="w-full" variant="on">
                  <p-inputnumber
                    inputId="lineQuantity"
                    [formControl]="form.controls.lineQuantity"
                    [min]="0.0001"
                    mode="decimal"
                    locale="en-US"
                    [minFractionDigits]="0"
                    [maxFractionDigits]="4"
                    fluid />
                  <label for="lineQuantity">Cantidad</label>
                </p-floatlabel>
              </div>
              <div class="flex flex-col gap-1">
                <p-floatlabel class="w-full" variant="on">
                  <p-inputnumber
                    inputId="lineUnitPrice"
                    [formControl]="form.controls.lineUnitPrice"
                    mode="decimal"
                    locale="en-US"
                    [min]="0"
                    [minFractionDigits]="2"
                    [maxFractionDigits]="4"
                    [useGrouping]="true"
                    fluid
                    class="[&_input]:text-right" />
                  <label for="lineUnitPrice">Precio unitario</label>
                </p-floatlabel>
              </div>
              <div class="flex flex-col gap-1">
                <p-floatlabel class="w-full" variant="on">
                  <p-inputnumber
                    inputId="lineSubtotal"
                    [ngModel]="lineSubtotal()"
                    [ngModelOptions]="{ standalone: true }"
                    mode="decimal"
                    locale="en-US"
                    [minFractionDigits]="2"
                    [maxFractionDigits]="4"
                    [useGrouping]="true"
                    fluid
                    class="[&_input]:text-right"
                    [readonly]="true"
                    [disabled]="true" />
                  <label for="lineSubtotal">Subtotal</label>
                </p-floatlabel>
                <small class="text-slate-500">Cantidad × precio unitario.</small>
              </div>
            </div>
            <div class="md:col-span-2 pt-3 mt-1 border-t border-slate-200">
              <button
                type="button"
                class="group inline-flex items-center gap-1.5 rounded px-1 py-1 -ml-1 text-xs text-slate-500 hover:text-slate-700 hover:bg-slate-50 transition-colors"
                (click)="lineFiscalDetailsExpanded.set(!lineFiscalDetailsExpanded())"
                [attr.aria-expanded]="lineFiscalDetailsExpanded()">
                <i
                  class="pi text-[0.65rem] text-slate-400 group-hover:text-slate-600"
                  [class.pi-chevron-right]="!lineFiscalDetailsExpanded()"
                  [class.pi-chevron-down]="lineFiscalDetailsExpanded()"></i>
                <span class="font-medium text-blue-500">Personalizar datos fiscales e impuestos</span>
              </button>
            </div>
            @if (lineFiscalDetailsExpanded()) {
              @if (!form.controls.lineProduct.value) {
                <p class="md:col-span-2 text-sm text-slate-500">Selecciona un producto para ver su configuración.</p>
              } @else {
                <div class="md:col-span-2 -mt-1">
                  <span class="text-sm font-medium text-slate-800">Datos fiscales</span>
                </div>
                <dl class="md:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3 text-sm">
                  <div>
                    <dt class="text-slate-500">Unidad de medida</dt>
                    <dd class="text-slate-800">{{ fiscalMeasureUnit() }}</dd>
                  </div>
                  <div>
                    <dt class="text-slate-500">Código fiscal</dt>
                    <dd class="text-slate-800">{{ fiscalTaxCode() }}</dd>
                  </div>
                  <div>
                    <dt class="text-slate-500">Objeto de impuesto SAT</dt>
                    <dd class="text-slate-800">{{ fiscalObjetoImp() }}</dd>
                  </div>
                  <div>
                    <dt class="text-slate-500">Precio con impuestos incluidos</dt>
                    <dd class="text-slate-800">{{ form.controls.lineProduct.value.taxInclusive ? 'Sí' : 'No' }}</dd>
                  </div>
                </dl>
                <div class="md:col-span-2 mt-2 border-t border-slate-200 pt-4">
                  <h4 class="text-sm font-semibold text-slate-700 mb-3">Impuestos del producto</h4>
                  @if (fiscalTaxes().length === 0) {
                    <p class="text-sm text-slate-500">Este producto no tiene impuestos configurados.</p>
                  } @else {
                    <div class="overflow-x-auto">
                      <table class="w-full text-sm">
                        <thead>
                          <tr class="border-b border-slate-200">
                            <th class="text-left py-2 text-slate-600 font-medium">Impuesto</th>
                            <th class="text-left py-2 text-slate-600 font-medium">Tasa</th>
                            <th class="text-left py-2 text-slate-600 font-medium">Aplicación</th>
                            <th class="text-left py-2 text-slate-600 font-medium">Tipo de cobro</th>
                          </tr>
                        </thead>
                        <tbody>
                          @for (tax of fiscalTaxes(); track tax.id) {
                            <tr class="border-b border-slate-100">
                              <td class="py-2 text-slate-800">{{ taxLabel(tax.tax) }}</td>
                              <td class="py-2 text-slate-700">{{ formatTaxRate(tax.taxRate) }}</td>
                              <td class="py-2 text-slate-700">{{ taxApplicationLabel(tax.applicationType) }}</td>
                              <td class="py-2 text-slate-700">{{ taxCollectionLabel(tax.collectionType) }}</td>
                            </tr>
                          }
                        </tbody>
                      </table>
                    </div>
                  }
                </div>
              }
            }
          </div>
        </div>
        <div class="flex shrink-0 justify-end gap-3 border-t border-slate-200 bg-slate-100 px-4 py-3">
          <p-button label="Cancelar" severity="secondary" (onClick)="closeLineDialog()" type="button" />
          <p-button [label]="editingLineIndex() == null ? 'Agregar' : 'Actualizar'" icon="pi pi-check" (onClick)="addLine()" type="button" />
        </div>
      </div>
    </div>
  }

  <p-dialog
    header="Enviar liga de pago"
    [visible]="sendDialogOpen()"
    (visibleChange)="sendDialogOpen.set($event)"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [dismissableMask]="!sending()"
    [closable]="!sending()"
    appendTo="body"
    [style]="{ width: 'min(28rem, calc(100vw - 2rem))' }">
    <div class="flex flex-col gap-4 pt-1">
      <p class="text-sm text-slate-600 m-0">Indica el correo al que se enviará la liga de pago.</p>
      <p-floatlabel variant="on">
        <input
          pInputText
          id="send-sale-link-email"
          class="w-full"
          type="email"
          autocomplete="email"
          [value]="sendEmail()"
          (input)="sendEmail.set($any($event.target).value)"
          [disabled]="sending()" />
        <label for="send-sale-link-email">Correo electrónico</label>
      </p-floatlabel>
    </div>
    <ng-template #footer>
      <div class="flex justify-end gap-2">
        <p-button label="Cancelar" severity="secondary" [text]="true" type="button" [disabled]="sending()" (onClick)="sendDialogOpen.set(false)" />
        <p-button label="Enviar" icon="pi pi-send" type="button" [loading]="sending()" [disabled]="sending() || !sendEmail().trim()" (onClick)="submitSend()" />
      </div>
    </ng-template>
  </p-dialog>

  <p-dialog
    header="Nuevo cliente"
    [visible]="customerDialogOpen()"
    (visibleChange)="customerDialogOpen.set($event)"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    appendTo="body"
    [style]="{ width: 'min(76rem, 96vw)' }"
    [contentStyle]="{ overflow: 'auto', maxHeight: '85vh', padding: '0' }">
    @if (customerDialogOpen()) {
      <app-customer-form
        [embedded]="true"
        (saved)="onCustomerSaved($event)"
        (dismissed)="customerDialogOpen.set(false)" />
    }
  </p-dialog>

  <p-dialog
    header="Nuevo producto"
    [visible]="productDialogOpen()"
    (visibleChange)="productDialogOpen.set($event)"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    appendTo="body"
    [style]="{ width: 'min(76rem, 96vw)' }"
    [contentStyle]="{ overflow: 'auto', maxHeight: '85vh', padding: '0' }">
    @if (productDialogOpen()) {
      <app-product-form
        [embedded]="true"
        (saved)="onProductSaved($event)"
        (dismissed)="productDialogOpen.set(false)" />
    }
  </p-dialog>

  <p-drawer
    [visible]="saleDetailsOpen()"
    position="right"
    (visibleChange)="onSaleDrawerVisibleChange($event)"
    styleClass="sale-details-drawer !w-[800px]"
    [blockScroll]="true">
    <ng-template pTemplate="header">
      <div class="flex items-center gap-3 min-w-0">
        <span class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-violet-100 text-violet-600 shadow-sm">
          <i class="pi pi-shopping-cart text-base"></i>
        </span>
        <h3 class="text-lg font-semibold text-slate-900">Detalle de venta</h3>
      </div>
    </ng-template>
    @if (saleDetailsLoading()) {
      <div class="flex flex-col items-center justify-center py-12 gap-4">
        <i class="pi pi-spin pi-spinner text-4xl text-sky-500"></i>
        <p class="text-sm text-slate-600">Cargando venta...</p>
      </div>
    } @else if (selectedSale()) {
      <app-sale-read
        [sale]="selectedSale()!"
        [charges]="saleCharges()"
        (openSubscription)="openSubscriptionDetails($event)"
        (openCustomer)="openCustomerDetails($event)" />
    }
  </p-drawer>

  <p-drawer
    [visible]="subscriptionDetailsOpen()"
    position="right"
    (visibleChange)="onSubscriptionDrawerVisibleChange($event)"
    styleClass="subscription-details-drawer !w-[800px]"
    [blockScroll]="true">
    <ng-template pTemplate="header">
      <div class="flex items-center gap-3 min-w-0">
        <span class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-teal-100 text-teal-600 shadow-sm">
          <i class="pi pi-sync text-base"></i>
        </span>
        <h3 class="text-lg font-semibold text-slate-900">Detalle de suscripción</h3>
      </div>
    </ng-template>
    @if (subscriptionDetailsLoading()) {
      <div class="flex flex-col items-center justify-center py-12 gap-4">
        <i class="pi pi-spin pi-spinner text-4xl text-teal-500"></i>
        <p class="text-sm text-slate-600">Cargando suscripción...</p>
      </div>
    } @else if (selectedSubscription()) {
      <app-subscription-read
        [subscription]="selectedSubscription()!"
        (openSale)="openSaleDetails($event)"
        (openCustomer)="openCustomerDetails($event)" />
    }
  </p-drawer>

  <p-drawer
    [visible]="customerDetailsOpen()"
    position="right"
    (visibleChange)="onCustomerDrawerVisibleChange($event)"
    styleClass="customer-details-drawer !w-[800px]"
    [blockScroll]="true">
    <ng-template pTemplate="header">
      <div class="flex items-center gap-3 min-w-0">
        <span class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-sky-100 text-sky-600 shadow-sm">
          <i class="pi pi-user text-base"></i>
        </span>
        <h3 class="text-lg font-semibold text-slate-900">Detalles del cliente</h3>
      </div>
    </ng-template>
    @if (customerDetailsLoading()) {
      <div class="flex flex-col items-center justify-center py-12 gap-4">
        <i class="pi pi-spin pi-spinner text-4xl text-sky-500"></i>
        <p class="text-sm text-slate-600">Cargando cliente...</p>
      </div>
    } @else if (selectedCustomer()) {
      <app-customer-read
        [customer]="selectedCustomer()!"
        (openSale)="openSaleDetails($event)" />
    }
  </p-drawer>
</div>
